import * as types from "./socio.actionType";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  Dto: {
    IdIdentificador: undefined,
    CpfCnpj: undefined,
    Nome: undefined,
    DataEntrada: undefined,
    Email: undefined,
    Telefone: undefined,
    RgIe: undefined,
    IdCcmSocio: undefined,
    EnderecoSocio: {},
  },
  showModalSocio: false,
  prefix: undefined,
  listaSocio: [],
  changeState: undefined,
});

const reduce = (state = initialState, action = {}) => {
  let { payload } = action;
  switch (action.type) {
    case types.MODAL_SOCIO_CLOSE:
      return state.merge({ showModalSocio: false, newOpen: false });
    case types.MODAL_SOCIO_OPEN:
      return state.merge({ showModalSocio: true, newOpen: true });
    case types.ADD_STATE_SOCIO_LISTGRID:
      return state.merge({
        listaSocio: [
          ...state.listaSocio,
          {
            ...payload,
            EnderecoSocioGrid: payload.EnderecoSocio
              ? (payload.EnderecoSocio.Cep ? payload.EnderecoSocio.Cep : "") +
                (payload.EnderecoSocio.Tipo
                  ? payload.EnderecoSocio.Tipo.hasOwnProperty("TipoLogradouro")
                    ? " - " + payload.EnderecoSocio.Tipo.TipoLogradouro
                    : " - " + payload.EnderecoSocio.Tipo
                  : "") +
                (payload.EnderecoSocio.Logradouro
                  ? " - " + payload.EnderecoSocio.Logradouro
                  : "") +
                (payload.EnderecoSocio.Numero
                  ? " - " + payload.EnderecoSocio.Numero
                  : "") +
                (payload.EnderecoSocio.Complemento
                  ? " - " + payload.EnderecoSocio.Complemento
                  : "") +
                (payload.EnderecoSocio.Bairro
                  ? " - " + payload.EnderecoSocio.Bairro
                  : "") +
                (payload.EnderecoSocio.Cidade
                  ? " - " + payload.EnderecoSocio.Cidade
                  : "") +
                (payload.EnderecoSocio.UF
                  ? " - " + payload.EnderecoSocio.UF
                  : "") +
                (payload.EnderecoSocio.Pais
                  ? " - " + payload.EnderecoSocio.Pais
                  : "")
              : null,
          },
        ],
      });
    case types.SET_NEW_OPEN:
      return state.merge({ newOpen: !state.newOpen });
    case types.SET_STATE_SOCIO:
      return state.merge({ Dto: { ...state.Dto, ...payload } });
    case types.SET_PREFIX_SOCIO:
      return state.merge({ prefix: payload });
    case types.SET_STATE_LIST_GRID_SOCIO:
      return state.merge({
        listaSocio: payload.map((socio) => {
          return {
            ...socio,
            EnderecoSocioGrid: socio.EnderecoSocio
              ? (socio.EnderecoSocio.Cep ? socio.EnderecoSocio.Cep : "") +
                (socio.EnderecoSocio.Tipo
                  ? socio.EnderecoSocio.Tipo.hasOwnProperty("TipoLogradouro")
                    ? " - " + socio.EnderecoSocio.Tipo.TipoLogradouro
                    : " - " + socio.EnderecoSocio.Tipo
                  : "") +
                (socio.EnderecoSocio.Logradouro
                  ? " - " + socio.EnderecoSocio.Logradouro
                  : "") +
                (socio.EnderecoSocio.Numero
                  ? " - " + socio.EnderecoSocio.Numero
                  : "") +
                (socio.EnderecoSocio.Complemento
                  ? " - " + socio.EnderecoSocio.Complemento
                  : "") +
                (socio.EnderecoSocio.Bairro
                  ? " - " + socio.EnderecoSocio.Bairro
                  : "") +
                (socio.EnderecoSocio.Cidade
                  ? " - " + socio.EnderecoSocio.Cidade
                  : "") +
                (socio.EnderecoSocio.UF ? " - " + socio.EnderecoSocio.UF : "") +
                (socio.EnderecoSocio.Pais
                  ? " - " + socio.EnderecoSocio.Pais
                  : "")
              : null,
          };
        }),
      });
    case types.SET_STATE_ENDERECO_SOCIO:
      return state.merge({ Dto: { ...state.Dto, EnderecoSocio: payload } });
    case types.RESET_STATE_SOCIO:
      return state.merge({ Dto: {} });
    case commonActionType.RESET:
      return state.merge({
        ...initialState,
        changeState: new Date().getTime(),
      });
    default:
      return state;
  }
};

store.registerDynamicModule("socio", reduce);
